<template>
    <common-page flex-column>
        <div id="project-info" class="content">
            <div class="card">
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                     data-parent="#accordionFilter">
                    <div class="card-body">
                        <h5><span class="text-primary">业务模块信息</span></h5>
                        <h6>名称：{{ businessModuleName }}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-1 p-2">
            <div class="d-flex align-items-center">
                <h5 class="text-primary mb-0">{{ '已配置的协议列表' }}</h5>
                <button class="btn btn-primary ml-3 ont-size-15" type="button" title="添加协议"
                        @click="openSelectDialog()">
                    添加协议
                </button>
            </div>
            <b-overlay :show="savingBusinessModuleAgreement && queryAgreementListLoading">
                <mini-table ref="agreementListResultTable"
                            read-only
                            needModelFields
                            :items="currentAgreementList"
                            :withCustomActionsEndOfRow=true
                            style="min-height: 350px;"
                            :row-key="'id'"
                            entity-name="sithMesAgreement">
                    <template #rightHeader>
                        <b-button class="ml-1" variant="success"
                                  :disabled="savingBusinessModuleAgreement"
                                  v-show="editAble"
                                  @click="saveBusinessModuleAgreement()">
                            保 存
                        </b-button>
                        <b-button class="ml-1 mr-1" :variant="editAble ? 'outline-warning' : 'outline-success'"
                                  v-if="currentAgreementList.length > 0"
                                  @click="triggerTableEdit()">
                            {{ editAble ? '关闭编辑' : '开启编辑' }}
                        </b-button>
                    </template>
                    <template #endOfRow="{row}">
                        <b-button variant="danger" v-if="editAble"
                                  @click="deleteSelectedRow(row)">
                            <i class="fa-solid fa-trash-can"></i>
                        </b-button>
                    </template>
                </mini-table>
            </b-overlay>
        </div>
        <template #outer>
            <el-dialog title="添加协议" :visible.sync="selectAgreementDialogVisible" width="85%"
                       :close-on-click-modal='false' append-to-body
                       @close='clearFilter'>
                <!-- 筛选框部分 -->
                <div>
                    <el-form :model="queryForm" ref="filterForm" label-width="auto" size="mini">
                        <el-row :gutter="10">
                            <el-col :span="6">
                                <el-form-item label="名称">
                                    <el-input v-model="queryForm.nameFilter"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="编码">
                                    <el-input v-model="queryForm.codeFilter"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="状态">
                                    <el-select v-model="queryForm.statusFilter" clearable>
                                        <el-option v-for="item in agreementStatus"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!-- 搜索和重置按钮 -->
                        <el-row>
                            <el-col :span="4" :offset="10">
                                <el-button type="primary" plain @click="searchItems" icon="el-icon-search"
                                           size="mini"
                                           :loading="inQuery">查询
                                </el-button>
                                <el-button type="warning" plain @click="resetFilter" icon="el-icon-delete" size="mini">
                                    重置
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 显示协议选择部分 -->
                <div class="mt-1">
                    <div class="row">
                        <div class="col-6">
                            <mini-table :items="searchResult"
                                        read-only
                                        needModelFields
                                        entity-name="sithMesAgreement"
                                        :hideCustomizeFieldButton=true
                                        @rowClick="chooseItem"></mini-table>
                        </div>
                        <div class="col-6">
                            <mini-table :items="chosenItems" read-only
                                        header-title="已选择"
                                        needModelFields
                                        :hideCustomizeFieldButton=true
                                        entity-name="sithMesAgreement"
                                        @rowClick="handleDelete"></mini-table>
                        </div>
                    </div>
                    <div class="mt-1 d-flex flex-row">
                        <el-button class="ml-auto" @click="selectAgreementDialogVisible=false">取消</el-button>
                        <el-button class="ml-1" type="primary" @click="assignAgreementToBusinessModule()">确认
                        </el-button>
                    </div>
                </div>
            </el-dialog>
        </template>
    </common-page>
</template>

<script>
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import CommonPage from "@/components/echarts-part/stuff/CommonPage";
import commonViewsUtil from "@/utils/commonViewsUtil";

export default {
    name: "AgreementList",
    mixins: [emCommonListMixin, emCommonApiMixin],
    components: {CommonPage, MiniTable},
    data() {
        return {
            originAgreementList: [],
            currentAgreementList: [],
            fields: [],
            editAble: false,
            queryAgreementListLoading: false,
            needAddedAgreementIds: [],
            needDeleteAgreementIds: [],
            savingBusinessModuleAgreement: false,
            selectAgreementDialogVisible: false,
            queryForm: {
                nameFilter: '',
                codeFilter: '',
                statusFilter: null
            },
            agreementStatus: [
                {
                    label: '启用',
                    value: 1
                }, {
                    label: '禁用',
                    value: 2
                }
            ],
            inQuery: false,
            searchResult: [],
            chosenItems: []
        }
    },
    created() {
        this.queryAgreementList();
        this.needAddedAgreementIds = [];
        this.needDeleteAgreementIds = [];
        this.currentAgreementList = []
    },
    computed: {
        businessModuleName() {
            return this.$route.query.businessModuleName
        },
        businessModuleId() {
            return this.$route.query.businessModuleId;
        },
        entityName() {
            return "sithMesAgreement";
        }
    },
    methods: {
        queryAgreementList() {
            this.queryAgreementListLoading = true
            let url = this.$_emApiMixin_entityBaseApi(this.entityName) + "/findByBusinessModuleId?businessModuleId=" + this.businessModuleId;
            this.$_emApiMixin_post(url, {})
                .then(response => {
                        const result = response.data
                        this.originAgreementList = result;
                        this.currentAgreementList = result;
                    }
                ).finally(() => this.queryAgreementListLoading = false)
        },
        triggerTableEdit(val) {
            if (val !== undefined) {
                this.editAble = val;
            } else {
                this.editAble = !this.editAble;
            }
        },
        deleteSelectedRow(row) {
            const index = this.currentAgreementList.findIndex(item => item.id === row.id);
            const originAgreementIds = this.originAgreementList.map(item => item.id)
            if (index !== -1) {
                this.currentAgreementList.splice(index, 1);
                if (originAgreementIds.includes(row.id)) {
                    this.needDeleteAgreementIds.push(row.id);
                }
            }
        },
        saveBusinessModuleAgreement() {
            this.$store.dispatch('api/post', {
                url: this.$store.state[this.entityName].baseModuleUrl + "/sithMesBusinessModuleAgreement/editAgreementList",
                data: {
                    businessModuleId: this.businessModuleId,
                    addedAgreementIds: this.needAddedAgreementIds,
                    deleteAgreementIds: this.needDeleteAgreementIds
                }
            }).then(() => {
                commonViewsUtil.showSuccess(this, "保存成功");
                this.queryAgreementList();
                this.editAble = false;
            }).finally(() => this.savingBusinessModuleAgreement = false);
        },
        openSelectDialog() {
            this.selectAgreementDialogVisible = true;
        },
        clearFilter() {
            this.inQuery = false;
            this.chosenItems = [];
        },
        resetFilter() {
            this.searchResult = [];
            this.queryForm.nameFilter = '';
            this.queryForm.codeFilter = '';
            this.queryForm.statusFilter = '';
        },
        searchItems() {
            this.inQuery = true
            this.$_emApiMixin_findByFilter(this.entityName, this.queryForm).then((response) => {
                this.searchResult = response;
            }).finally(() => this.inQuery = false);
        },
        chooseItem(row) {
            let indexOf = this.chosenItems.indexOf(row);
            if (indexOf === -1) {
                this.chosenItems.push(row);
            } else {
                this.chosenItems.splice(indexOf, 1);
            }
        },
        handleDelete(row, index) {
            this.chosenItems.splice(index, 1);
        },
        assignAgreementToBusinessModule() {
            let currentAgreementIds = this.currentAgreementList.map(item => item.id);
            const originAgreementIds = this.originAgreementList.map(item => item.id)
            this.chosenItems.forEach(item => {
                if (!currentAgreementIds.includes(item.id)) {
                    this.currentAgreementList.push(item);
                    if (!originAgreementIds.includes(item.id)) {
                        this.needAddedAgreementIds.push(item.id);
                    }
                }
            });
            this.selectAgreementDialogVisible = false;
            this.triggerTableEdit(true);
        }
    }
}
</script>

<style scoped>
</style>
